import axios from 'axios';
import React, {useEffect,useState} from 'react';
import ReactDOM  from 'react-dom';
import { useProductContext } from '../Utility/ProductContext';
import { useAuth } from '../Context/AuthContext';
import { Helmet } from 'react-helmet';
const Utility= require('../Utility/Utilty');


export default function ViewPost({ ID, userID, UpdateBagCount }) {
    //use id to  process fetch data here
    //const {authUser, isLoggedIn, countItems, UpdateBagCount ,setAuthUser ,setIsLoggedIn } =useAuth();
    const [product, setProducts] = useState([]); 
    const [prodPrice, setProdPrice]=useState(0.00);
    const [prodDiscount, setProdDiscount]=useState(0.0);       
    const [ItemData, setItemData] = useState({
        ID: null,
        ProductID: null,
        SelectedSize: null,
        Quantity: null,
        TotalPrice: null,
        UserID: userID,
        OrderID: '999'
});
const [inputError, setInputError] = useState(null);





    
   const addProduct = async (e) => {
    e.preventDefault();
    console.log(ItemData);
    if (userID===null){
       setInputError('You are not Logged in.\nPlease Login or Create an account to add to your bag.');
       return
    }


    try {
      const formData = new FormData();      
      formData.append('ProductID', product.ID);
      formData.append('TotalPrice', ItemData.TotalPrice);
      formData.append('SelectedSize', ItemData.SelectedSize);
      formData.append('UserID', userID);
      formData.append('Quantity', 1);
      formData.append('OrderID', ItemData.OrderID);
     

      const response = await axios.post('/addToBag', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('Item added successfully:', response.data);
    
      //fetchData();
      UpdateBagCount();
      
    } catch (error) {
      console.error('Error adding item:', error);
    }
  };




    useEffect(() => {
        // Fetch newProducts when the component mounts
        fetch(`/load?filter=ID='${ ID }'`)
            .then(response => response.json())
            .then(data => setProducts(data[0]))  
            .catch(error => console.error('Error fetching newProducts:', error));

        }, [ID]); // Empty dependency array ensures the effect runs only once

    useEffect(() => {
        const selectedsize=document.getElementById('selectedSize');
        const quantity=document.getElementById('quantity');

        setItemData({
            ID : null,
            ProductID : product.ID||null,
            SelectedSize : selectedsize ? selectedsize.value || null : null,
            Quantity : 1,
            TotalPrice : parseFloat(product.Price)-( parseFloat(product.Price)*( parseFloat(product.Discount)/100 ) ),
            UserID : userID || null,
            //OrderID = ItemData null
        });

        }, [product]);    
        

        const handleChange = (name, value) => {
            console.log('Updating:', name, 'with value:', value);
            setItemData((prevData) => ({
              ...prevData,      
              [name]: value,
            }));
        };
        
        const util = new Utility();

        useEffect(() => { 
            const disc=product.Discount? parseFloat(product.Discount): 0;
            let price=product.Price? parseFloat(product.Price): 0;           
            price = price - (price*disc/100);
            setProdPrice(price);
            setProdDiscount(disc);
           
          }, [product]); 
        
    
    return (
        <>
        <Helmet>
            <style>{`
            .shop-post-descr {
                    height: unset;
                    padding: 0.1rem;
                    font-size: smaller;
                    min-width: 10vh;
                    text-align: start;
                }
            `}
            </style>
        </Helmet>
        
        <div id="view-post-overlay"  style={{ display:"flex" }}>
            
        <img className="vop-logo" src="assets/imgs/bywaldo-logo.png" alt="byWaldo Logo" />
        <div>
            <h4 id={ID} className="close-btn" onClick={hideViewPost}>X</h4>
        </div>
        {(typeof product === 'undefined')?
        (
            <div>Apologies, Item is not available.</div>
        ):(
        
        <div id="view-post">
             
             {( product.InStocKQ > 0 )?
        (
            <div>Apologies, Item is not available.</div>
        ):(
            <>
            <div className="image-container">
                <div className="selectable-cont">
                    <img id="Img1" onClick={(e) => { selectImg(e); } } src={util.getImageUrl(product.ImageType0,product.Image0)} className="selectable-img selected" alt="P1" />
                    <img id="Img2" onClick={(e) => { selectImg(e); } } src={util.getImageUrl(product.ImageType1,product.Image1)} className="selectable-img" alt="P2" />
                    <img id="Img3" onClick={(e) => { selectImg(e); } } src={util.getImageUrl(product.ImageType2,product.Image2)} className="selectable-img" alt="P3" />
                </div>
                <img id="mainImg" src={util.getImageUrl(product.ImageType0,product.Image0)} className="imgfit" alt="Main" />
            </div>
            <div className="shop-post-descr mb-2">
                    <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>{product.Description}</span>
                        <span className="d-flex text-end">
                            <span className="custom-dropdown">
                                <select id='selectedSize' onChange={(e) => handleChange('SelectedSize', e.target.value)} >
                                    <option value="XS">XS</option>
                                    <option value="S">S</option>
                                    <option value="M">M</option>
                                    <option value="L">L</option>
                                    <option value="XL">XL</option>
                                    <option value="Custom">Custom</option>
                                </select>
                            </span>
                        </span>
                    </p>
                    <p className='text-muted small mb-0'>Range</p>
                    <p className="df-100 mb-0 align-items-center">                        
                        <span>
                            <svg enableBackground="new 0 0 50 50" height="1.25rem" id="Layer_1" version="1.1" viewBox="0 0 50 50" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <rect fill="none" height="50" width="50" />
                                <circle cx="39" cy="11" fill="none" r="3" stroke="black" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
                                <path d="M47,5.5  C47,4.119,45.881,3,44.5,3c-0.156,0-14.876,0.002-14.876,0.002c-1.33,0-2.603-0.07-3.341,0.668L3.554,26.398  c-0.739,0.738-0.739,1.936,0,2.674l17.374,17.374c0.738,0.738,1.936,0.738,2.674,0L46.33,23.717c0.738-0.737,0.668-1.98,0.668-3.34  C46.998,20.377,47,5.656,47,5.5z"
                                    fill="none" stroke="black" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" />
                            </svg>
                        </span>
                        <span className="ml-1"> &plusmn;ZAR {prodPrice}
                            {(product.Discount>0)?(
                            <span className='ml-2 text-danger strikethrough'>{`ZAR ${product.Price}`}</span>
                            ):(<></>)}
                        </span>
                    </p>
                    <p className='f-xsmall mb-2 mt-3 p-1 text-center text-muted w-100'>Cost for items are subject to an average maximum &plusmn;25% change depending on your requirements.</p>
                    <div className="d-flex justify-content-between mt-1 align-items-end">
                        <a href="#size-chart" className="text-muted" style={{ fontSize: 'smaller' }} onClick={showCart}>
                            <span id="chartToggle">{'>'}</span>
                            Size Chart</a>
                        <button id={`btn_${product.ID}`} className="align-items-center border-0 breadcrumb d-flex float-right p-2" 
                            type="button" onClick={addProduct}>
                            <span>
                                <svg margin="1vh" height="1.325rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="none" strokeWidth="1" stroke="#454343" fillRule="evenodd" clipRule="evenodd" d="M9.44722 2.1056C9.9412 2.35259 10.1414 2.95326 9.89444 3.44724L8.10558 7.02495C7.85859 7.51893 7.25792 7.71915 6.76394 7.47216C6.26996 7.22517 6.06974 6.6245 6.31673 6.13052L8.10558 2.55281C8.35257 2.05883 8.95324 1.85861 9.44722 2.1056Z" />
                                    <path fill="none" strokeWidth="1" stroke="#454343" fillRule="evenodd" clipRule="evenodd" d="M14.5528 2.10558C15.0468 1.85859 15.6475 2.05882 15.8945 2.5528L17.6833 6.1305C17.9303 6.62448 17.7301 7.22516 17.2361 7.47214C16.7421 7.71913 16.1414 7.51891 15.8945 7.02493L14.1056 3.44722C13.8586 2.95324 14.0588 2.35257 14.5528 2.10558Z" />
                                    <path fill="none" strokeWidth="1" stroke="#454343" fillRule="evenodd" clipRule="evenodd" d="M6.45925 6C4.02505 6 2.1552 8.15595 2.49945 10.5657L3.51965 17.7071C3.87155 20.1704 5.98115 22 8.4694 22H15.531C18.0193 22 20.1289 20.1704 20.4808 17.7071L21.501 10.5657C21.8452 8.15595 19.9754 6 17.5412 6H6.45925ZM12 10C12.5523 10 13 10.4477 13 11V13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13H11V11C11 10.4477 11.4477 10 12 10Z" />
                                </svg>
                            </span>
                            <span className="ml-1">BAG</span>
                        </button>
                    </div>
            </div>
            {inputError && <div className='lblError'>{inputError}</div>}
            <div id="size-chart" className='size-chart' style={{display: 'none'}}>
                <img id="sizeChart" src="assets/imgs/SizeChart.JPEG" className="imgfit" alt="sc" />
            </div>
            </>

            )}

        </div>
        
    )}
        </div>
    </>
  );
};


const selectImg=(e)=>{
    //console.log(e)
    const id=e.currentTarget.id; 
    //console.log("id:"+id);

    const img1=document.getElementById("Img1");
    const img2=document.getElementById("Img2");
    const img3=document.getElementById("Img3");
    const ImgArr=[img1,img2,img3];

    ImgArr.forEach(elimg => {
        if(elimg.classList.contains("selected"))
        {
            elimg.classList.remove("selected");
        }
    }); 

    const selectedImg=document.getElementById(id);
    selectedImg.classList.add("selected");
    const newimgSrc=selectedImg.getAttribute("src")
    //console.log("new imgsrc: "+newimgSrc);
    const mainImg=document.getElementById("mainImg");
    mainImg.removeAttribute("src");
    mainImg.setAttribute("src",newimgSrc);

}

function hideViewPost() {
    // Hide the view-post overlay

    const viewpost=document.getElementById('view-post-overlay');
    const viewpostDiv=document.getElementById('viewpostDiv');    
    viewpostDiv.style.display = 'none';
    viewpost.style.display = 'none';
    viewpost.remove();
    viewpostDiv.remove();
    //ReactDOM.unmountComponentAtNode(viewpost);
    
}

function showCart(e){
    e.preventDefault();
    const toggle=document.getElementById('chartToggle');
    const chartView=document.getElementById('size-chart');
    if(chartView && toggle){
        if(chartView.style.display==="none"){ 
            toggle.innerText="v";          
            chartView.style.display="block";
            chartView.scrollIntoView({ behavior: 'smooth' })
        }
        else{
            toggle.innerText=">";           
            chartView.style.display="none";
        }
    }


}